import { GameGoalFlag } from '../../Game/Enums';
import LevelPopupType from '../components/UI/LevelPopup/Enums';

const defaultState = {
    activeType: LevelPopupType.NONE,
    name: 'Onbekend',
    description: '...',
    goals: GameGoalFlag.DIE,
    levelIndex: 1,
    onClose: () => {
        console.warn('On Close Level Popup callback is not set!');
    },
    onRestart: () => {
        console.warn('On Restart Level Popup callback is not set!');
    }
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'LEVEL_POPUP_OPEN_WITH_INFO': {
            const { payload } = action;
            const { type, info } = payload;
            return {
                ...state,
                activeType: type,
                name: info.name,
                description: info.description,
                goals: info.goals,
                levelIndex: info.levelIndex,
                onClose: info.onClose,
                onRestart: info.onRestart
            };
        }
        case 'LEVEL_POPUP_OPEN': {
            const { payload } = action;

            return {
                ...state,
                activeType: payload
            };
        }
        case 'LEVEL_POPUP_CLOSE': {
            return {
                ...state,
                activeType: LevelPopupType.NONE
            };
        }
        case 'LEVEL_POPUP_SET_ALL_INFO': {
            const { payload } = action;
            return {
                ...state,
                name: payload.name,
                description: payload.description,
                goals: payload.goals
            };
        }
        case 'LEVEL_POPUP_SET_NAME': {
            return {
                ...state,
                name: action.payload
            };
        }
        case 'LEVEL_POPUP_SET_DESCRIPTION': {
            return {
                ...state,
                description: action.payload
            };
        }
        case 'LEVEL_POPUP_SET_GOALS': {
            return {
                ...state,
                goals: action.payload
            };
        }
        case 'LEVEL_POPUP_SET_INDEX': {
            return {
                ...state,
                levelIndex: action.payload
            };
        }
        case 'LEVEL_POPUP_SET_CLOSE_CALLBACK': {
            return {
                ...state,
                onClose: action.payload
            };
        }
        case 'LEVEL_POPUP_SET_RESTART_CALLBACK': {
            return {
                ...state,
                onRestart: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
